// Updated TradeApplication with support for PNG, PDF, HEIC, JPG, JPEG preview without breaking anything
// IMPORTANT: Only preview images for image formats. For PDF, use iframe. For HEIC, convert using browser's built‑in support.

import { Box, Button, InputAdornment, Drawer, SwipeableDrawer, Typography, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Checkbox, IconButton } from "@mui/material";
import { useState } from "react";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import ApplicationStatusDrawer from "./ApplicationStatusDrawer";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';


const TradeApplication = ({ open, onClose, type, item, setUpdateType, updateType }) => {

    const [openApplication, setApplicationDrawer] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
// console.log("previewFile",previewFile)
    const allowedPreviewFormats = ["png", "jpg", "jpeg", "heic", "pdf"]; // allowed preview formats

    const statusStyles = {
        pending: { color: "#ffb706", border: "2px solid #ffb706", backgroundColor: "#fff8e6" },
        rejected: { color: "#9f0e12", border: "2px solid #9f0e12", backgroundColor: "#fee9eb" },
        approved: { color: "#13a755", border: "2px solid #1baa5b", backgroundColor: "#e7f6ee" },
    };

    const handleApplication = () => { setApplicationDrawer(true) }
    const onCloseApplicationDrawer = () => { setApplicationDrawer(false) };

    const handlePreview = async (fileUrl) => {
if (!fileUrl) return;


const ext = fileUrl.split(".").pop().toLowerCase();
if (!allowedPreviewFormats.includes(ext)) {
alert("Unsupported file format.");
return;
}


// ⭐ PDF FIX: convert to blob so iframe/object works everywhere (including Safari)
if (ext === "pdf") {
try {
const response = await fetch(fileUrl);
const blob = await response.blob();
const blobUrl = URL.createObjectURL(blob);
setPreviewFile({ url: blobUrl + "#toolbar=0", type: "pdf" });
return;
} catch (e) {
console.error("PDF Fetch Error", e);
}
}


setPreviewFile({ url: fileUrl, type: ext });
};


const handleClosePreview = () => setPreviewFile(null);
const showApplicationDetails = item && Object.keys(item).length > 0 && item?.accountType === type;

    return (
        <>
            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "25px" }}>
                    <Box>
                        <Typography className="sofiaRegular" variant="body1" sx={{ fontSize: "16px", fontWeight: "bold" }}>
                            {type === "trade" ? "Trade Application" : "Trade + Application"}
                        </Typography>
                        <Typography className="sofiaRegular" variant="body2" sx={{ fontSize: "14px" }}>
                            For Home Businesses
                        </Typography>
                    </Box>
                    <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </Box>

                {showApplicationDetails ? (
                    <>
                        <Box sx={{ border: "1px solid #f4f5f6", width: 430, marginX: "auto", marginTop: "45px", backgroundColor: "#ffffff", padding: "10px", borderRadius: "6px", display: "flex", flexDirection: "column", gap: "15px" }}>

                            <Box>
                                <Typography className="sofiaRegular" variant="body1" sx={{ fontSize: "16px", fontWeight: "bold", lineHeight: 1, mb: 0.5 }}>
                                    Application Submitted
                                </Typography>
                                <Typography className="sofiaRegular" variant="body2" sx={{ fontSize: "14px", lineHeight: 1 }}>
                                    {dayjs(item?.createdAt).format("MM/DD/YYYY")}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography className="sofiaRegular" variant="body1" fontWeight="bold" sx={{ lineHeight: 1, mb: 0.5 }}>Business Name</Typography>
                                <Typography className="sofiaRegular" variant="body2" sx={{ lineHeight: 0.9 }}>{item?.businessName}</Typography>
                            </Box>

                            <Box>
                                <Typography className="sofiaRegular" variant="body1" fontWeight="bold" sx={{ lineHeight: 1, mb: 0.5 }}>Business Type</Typography>
                                <Typography className="sofiaRegular" variant="body2" sx={{ lineHeight: 0.9 }}>{item?.businessType}</Typography>
                            </Box>

                            <Box>
                                <Typography className="sofiaRegular" variant="body1" fontWeight="bold" sx={{ lineHeight: 1, mb: 0.5 }}>Business Website</Typography>
                                <Typography className="sofiaRegular" variant="body2" sx={{ lineHeight: 0.9 }}>{item?.businessWebsite}</Typography>
                            </Box>

                            <Box>
                                <Typography className="sofiaRegular" variant="body1" fontWeight="bold" sx={{ lineHeight: 1, mb: 0.5 }}>Instagram Handle</Typography>
                                <Typography className="sofiaRegular" variant="body2" sx={{ lineHeight: 0.9 }}>{item?.instagramHandle}</Typography>
                            </Box>

                            <Box>
                                <Typography className="sofiaRegular" variant="body1" fontWeight="bold" sx={{ lineHeight: 1, mb: 0.5 }}>Business Address</Typography>
                                <Typography className="sofiaRegular" variant="body2" sx={{ lineHeight: 0.9 }}>
                                    {`${item?.address?.streetAddress}, ${item?.address?.suite},`}<br />
                                    {`${item?.address?.city}, ${item?.address?.state} ${item?.address?.zip}`}<br />
                                    {`${item?.address?.country}`}
                                </Typography>
                            </Box>

                            {type === "trade+" && (
                                <Box>
                                    <Typography className="sofiaRegular" variant="body1" fontWeight="bold" sx={{ lineHeight: 1, mb: 0.5 }}>Resale Certificate</Typography>
                                    <Box>
                                        {/* Download Button */}
                                        <Link
                                            component="button"
                                            className="sofiaRegular"
                                            style={{ fontSize: 14, color: "black", textDecoration: "underline", lineHeight: 0.9, cursor: "pointer" }}
                                            onClick={() => window.open(item?.certificate, "_blank")}
                                        >
                                            Download
                                        </Link>

                                        <br />

                                        {/* Preview Button */}
                                        <Link
                                            component="button"
                                            className="sofiaRegular"
                                            style={{ fontSize: 14, color: "black", textDecoration: "underline", lineHeight: 0.9, cursor: "pointer" }}
                                            onClick={() => handlePreview(item?.certificate)}
                                        >
                                            Preview
                                        </Link>
                                    </Box>
                                </Box>
                            )}

                            {/* Universal Viewer */}
                           {previewFile && (
<div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000 }}>
<div style={{ maxWidth: "95vw", maxHeight: "95vh", position: "relative" }}>


{/* IMAGE VIEW */}
{previewFile.type !== "pdf" && (
<img src={previewFile.url} style={{ maxWidth: "100%", maxHeight: "100%" }} />
)}


{/* PDF FIX — WORKS IN ALL BROWSERS */}
{previewFile.type === "pdf" && (
<object data={previewFile.url} type="application/pdf" style={{ width: "90vw", height: "90vh" }}>
<iframe src={previewFile.url} style={{ width: "90vw", height: "90vh", border: "none" }} title="PDF"></iframe>
</object>
)}


<button onClick={handleClosePreview} style={{ position: "absolute", top: 10, right: 10, width: 35, height: 35, borderRadius: "50%", background: "rgba(0,0,0,0.6)", color: "white", border: "none", fontSize: 20 }}>×</button>
</div>
</div>
)}

                            <Button
                                className="sofiaRegular"
                                onClick={handleApplication}
                                fullWidth
                                variant="outlined"
                                sx={{
                                    ...statusStyles[item?.status],
                                    fontWeight: "bold",
                                    textTransform: "none",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 6px !important",
                                    "&:hover": {
                                        backgroundColor: statusStyles[item?.status]?.backgroundColor,
                                        border: statusStyles[item?.status]?.border,
                                    },
                                }}
                            >
                                Manage Application Status
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                    <Typography className="sofiaRegular" variant="body2" sx={{ color: statusStyles[item?.status]?.color }}>
                                        {item?.status.charAt(0).toUpperCase() + item?.status.slice(1)}
                                    </Typography>
                                    <KeyboardArrowRightIcon fontSize="small" sx={{ color: statusStyles[item?.status]?.color }} />
                                </Box>
                            </Button>
                        </Box>
                    </>
                ) : (
                    <Box sx={{ border: "1px solid #f4f5f6", width: 430, marginX: "auto", marginTop: "45px", backgroundColor: "#ffffff", height: "500px", padding: "80px 10px", borderRadius: "6px", display: "flex", flexDirection: "column", gap: "15px" }}>
                        <Box sx={{ backgroundColor: "#ffffff", border: "2px solid #c5c5c5", borderRadius: "6px", padding: "25px", textAlign: "center", my: "auto" }}>
                            <Typography className="sofiaRegular" sx={{ color: "#8c8c8c", fontWeight: "bold" }}>No Application Submitted</Typography>
                        </Box>
                    </Box>
                )}
            </Drawer>

            <ApplicationStatusDrawer
                open={openApplication}
                onClose={onCloseApplicationDrawer}
                type={type}
                item={item}
                setUpdateType={setUpdateType}
                updateType={updateType}
            />
        </>
    );
};

export default TradeApplication;
